// Composables
/* import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    component: () => import('@/layouts/default/Default.vue'),
    children: [
      {
        path: '',
        name: 'Home',
        
        component: () => import('@/views/Home.vue'),
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
 */
import { createWebHistory, createRouter } from "vue-router";
const Login = () => import("@/views/auth/Login.vue")
const DashboardPage = () => import("@/views/dashboard/Dashboard.vue")
const VoucherPage = () => import("@/views/voucher/index.vue")
const TransactionHistoryPage = () => import("@/views/transactionHistory/index.vue")

const SessionHistoryPage = () => import("@/views/analytics/session.vue")
/** Subscribers components end here */

import store from '../store';

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
    meta: {
      title: "Login"
    }
  },

  {
    path: "/:encodedHotspotId",
    component: Login,
    meta: {
      title: "Login"
    }
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: DashboardPage,
    meta: {
      title: "Dashboard"
    }
  },
  {
    path: "/session",
    name: "Session",
    component: SessionHistoryPage,
    meta: {
      title: "Session"
    }
  },

  {
    path: "/voucher",
    name: "Voucher",
    component: VoucherPage,
    meta: {
      title: "Voucher"
    }
  },
  {
    path: "/trasaction-history",
    name: "Transaction History",
    component: TransactionHistoryPage,
    meta: {
      title: "Transaction History"
    }
  },
  /********************************************/
  { path: '/:pathMatch(.*)*', redirect: "/" },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  /* Check user have role */

  const publicPages = [''];

  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');

  const pageTitle = to.meta.title !== undefined ? 'QSMP | ' + to.meta.title : 'QSMP';
  document.title = pageTitle;

  // trying to access a restricted page + not logged in
  // redirect to login page
 
  if (!loggedIn) {
    
    if(to.params.encodedHotspotId)
    {
      const encodedHotspotId = to.params.encodedHotspotId;
      localStorage.removeItem('encodedHotspotId');
      if (encodedHotspotId =='null') {
     
        //window.location.href=process.env.VUE_APP_SMP_URL;
        //window.location.href=window.env.VUE_APP_SMP_URL;
        next();
      }
      else{
        localStorage.setItem('encodedHotspotId', encodedHotspotId);
        next();
      }
     
    }else{
      if(localStorage.getItem('encodedHotspotId'))
      {
        next('/'+localStorage.getItem('encodedHotspotId'));
      }else{
       next('/login');
        //window.location.href='/';
      }
     
    }
  } else {
    next();
  }

});


export default router;